import { Route, Redirect } from 'react-router-dom';
import { observer } from 'mobx-react';
import auth from '../../store/auth.js'
import AuthorizedLayout from '../../layouts/authorized-layout/authorized-layout.jsx';
import InitialLayout from '../../layouts/initial-layout/initial-layout';

const AuthRoute = observer(({ ...params }) => {
    const isLoggedIn = auth.isLoggedIn;
    const isInitializing = auth.isInitializing;
    const { component, ...other } = params;
    let InnerComponent = component;
    return (
        <Route {...other} render={
            () => {
                if (isInitializing) {
                    return (
                        <InitialLayout />
                    )
                } else {
                    if (isLoggedIn && !isInitializing) {
                        return (
                            <AuthorizedLayout>
                                <InnerComponent />
                            </AuthorizedLayout>
                        )
                    } else {
                        return (
                            <Redirect to="/" />
                        )
                    }
                }
            }
        }
        />
    )
});

export default AuthRoute;